// modules
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { addModal } from 'weblite-web-modal-viewer'
// component
import { NotifBlocked } from './notif-blocked'

const COMPONENT_ID = 'armanemaNotifBlocked'

export const showArmanemaNotifBlocked = () => addModal({ id: COMPONENT_ID })

export default {
  [COMPONENT_ID]: {
    Component: NotifBlocked,
  },
}
